export const SET_FEATURE_LIST = "SET_FEATURE_LIST";
export const UPDATE_FEATURE_LIST = "UPDATE_FEATURE_LIST ";
export const MSG = "MSG";
